import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";

export default class SampleInformationInput extends React.Component {
  fetchData = search => {
    const { company_id } = this.props;
    return fetchJson("/products/sample_information.json", {
      company_id,
      search
    }).then(records => records.map(m => ({ label: m.name, value: m.id })));
  };

  render() {
    const { onChange, multiple } = this.props;
    return (
      <AsyncSelect
        placeholder={"Pick Sample Information..."}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={customStyles()}
        id="si_id"
        loadOptions={this.fetchData}
        defaultOptions={true}
        onChange={onChange}
      />
    );
  }
}
